import { render, staticRenderFns } from "./DividerEdit.vue?vue&type=template&id=2d10d326&scoped=true"
import script from "./DividerEdit.vue?vue&type=script&lang=js"
export * from "./DividerEdit.vue?vue&type=script&lang=js"
import style0 from "./DividerEdit.vue?vue&type=style&index=0&id=2d10d326&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d10d326",
  null
  
)

export default component.exports